import { BezierEdge, BezierEdgeModel } from "@logicflow/core";

class FlowLinkModel extends BezierEdgeModel {
  constructor(data, graphModel) {
    super(data, graphModel);
    this.text.draggable = false;
    this.text.editable = false;
  }
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.strokeWidth = 3;
    style.stroke = this.isSelected ? '#ff7f0e' : '#999';
    return style;
  }
}
class FlowLink extends BezierEdge {}

export default {
  type: 'flow-link',
  view: FlowLink,
  model: FlowLinkModel
}

